var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'auth-default-layout',
        {
            'auth-default-layout--no-max-height': _vm.noMaxHeight,
        } ]},[_c('transition',{attrs:{"name":"appear-","appear":""}},[_c('div',{staticClass:"auth-default-layout__container"},[_c('AuthHeaderLayout'),_c('main',{staticClass:"auth-default-layout__body"},[_vm._t("default"),_vm._t("aside"),_vm._t("content")],2)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }